"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SuccessIcon_1 = __importDefault(require("./SuccessIcon"));
function BigCard(props) {
    var bigCardData = props.bigCardData, _a = props.theme, theme = _a === void 0 ? '' : _a;
    var title = bigCardData.title, desc = bigCardData.desc, _b = bigCardData.list, list = _b === void 0 ? [] : _b, btnTxt = bigCardData.btnTxt, btnHref = bigCardData.btnHref, extendProps = bigCardData.extendProps;
    return (react_1.default.createElement("div", { className: "big-card" },
        react_1.default.createElement("div", { className: "big-card-bg ".concat(theme, "-big-card") },
            react_1.default.createElement("div", { className: "header ".concat(theme, "-theme") },
                react_1.default.createElement("div", { className: "title" }, title),
                react_1.default.createElement("div", { className: "desc" }, desc)),
            react_1.default.createElement("div", { className: "footer" },
                react_1.default.createElement("ul", { className: "content" }, list.map(function (item, index) {
                    var txt = (item || {}).txt;
                    return (index < 3 && (react_1.default.createElement("li", { key: index, className: "txt" },
                        react_1.default.createElement(SuccessIcon_1.default, { theme: theme }),
                        react_1.default.createElement("span", null, txt))));
                })),
                react_1.default.createElement("div", { className: "btn ".concat(theme, "-theme") },
                    react_1.default.createElement("a", __assign({ className: "href", href: btnHref }, (extendProps || {})), btnTxt))))));
}
exports.default = BigCard;
//# sourceMappingURL=BigCard.js.map